import React from 'react';
import { Page, Banner, SkeletonPage, SkeletonBodyText } from '@shopify/polaris';
import { useStore } from '../providers/StoreProvider';

/**
 * AppLayout - Central loading/error gate for embedded app pages.
 *
 * Shows a single stable skeleton from mount until both auth and store data
 * are fully loaded. This prevents layout flicker when transitioning between
 * the auth-loading and data-loading phases.
 */
function AppLayout({ children }) {
  const { authLoading, authError, isLoading, shop, isAuthenticated } = useStore();

  // Show error banner if auth failed
  if (authError) {
    return (
      <Page title="Authentication Error">
        <Banner tone="critical">
          <p>{authError}</p>
          {shop && (
            <p>
              <a href={`/auth/install?shop=${shop}`}>Click here to reinstall the app</a>
            </p>
          )}
        </Banner>
      </Page>
    );
  }

  // Single gate: show skeleton until everything is ready
  if (authLoading || isLoading || !isAuthenticated) {
    return (
      <SkeletonPage primaryAction>
        <SkeletonBodyText lines={4} />
      </SkeletonPage>
    );
  }

  return <>{children}</>;
}

export default AppLayout;
